module.exports = __webpack_public_path__ + "img/flood-car-water-fill-white.c77eca16.svg";